module.exports = __webpack_public_path__ + "static/media/straven_5.718ff866.jpg";